import React, { useEffect } from 'react';
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import TabelaListagemExpandable from '../../../../components/TabelaListagem/TabelaListagemExpandable';
import moment from 'moment';
export default function TabelaContratos({ items, paging = true, ficha = false, qrCode, actionsExpandable }) {

    const itemsTable = items.map(value => {
        //formatando as datas de vigencia de cada contrato
        if (value.contratos) {
            const contratos = value.contratos.map(contratoV => {
                const contrato = { ...contratoV };
                if (contrato.inicioVigencia) {
                    contrato.inicioVigencia = moment(contrato.inicioVigencia).format("DD/MM/YYYY");
                }
                if (contrato.terminoVigencia) {
                    contrato.terminoVigencia = moment(contrato.terminoVigencia).format("DD/MM/YYYY");
                }
                return contrato;
            });
            return { ...value, contratos: [...contratos] };
        } else {
            const contrato = { ...value };
            if (contrato.inicioVigencia) {
                contrato.inicioVigencia = moment(contrato.inicioVigencia).format("DD/MM/YYYY");
            }
            if (contrato.terminoVigencia) {
                contrato.terminoVigencia = moment(contrato.terminoVigencia).format("DD/MM/YYYY");
            }
            return contrato;

        }
    });

    const headersTabelaEnderecos = [
        { value: "CEP", objectValue: "cep", align: "left" },
        { value: "UF", objectValue: "uf", align: "left" },
        { value: "Cidade", objectValue: "cidade", align: "left" },
        { value: "Bairro", objectValue: "bairro", align: "left" },
        { value: "Logradouro", objectValue: "logradouro", align: "left" },
        { value: "Número", objectValue: "numero", align: "right" },
        { value: "Complemento", objectValue: "complemento", align: "left" },
        { value: "Regional", objectValue: "tbSetores_Descricao", align: "left" },
        { value: "Principal", objectValue: "principal", align: "left" }
    ];
    const headersExpandable = [
        { value: "Modalidade", objectValue: "modalidade", align: "left" },
        { value: "Situação", objectValue: "situacaoContrato", align: "left" },
        { value: "Frequência", objectValue: "frequencia", align: "left" },
        { value: "Calendário", objectValue: "calendario", align: "left" },
        { value: "Unidade de medida", objectValue: "unidadeMedida", align: "left" },
        { value: "Quantidade contratada", objectValue: "quantidadeContratada", align: "right" },
        { value: "Número", objectValue: "numeroContrato", align: "right" },
        { value: "Transportador", objectValue: "nomeFantasiaTransportador", align: "right" },
        { value: "Início Vigência", objectValue: "inicioVigencia", align: "center" },
        { value: "Final Vigência", objectValue: "terminoVigencia", align: "center" },
        !ficha ? {} : { value: "Anexo", objectValue: "anexo", align: "center" },
    ]

    if (!ficha) {
        return (
            <TabelaListagemExpandable
                title={"Lista de contratos"}
                expandableRows={"contratos"}
                expandableHeaders={headersExpandable}
                expandableColSpan={headersTabelaEnderecos.length + 1}
                actionsExpandable={actionsExpandable}
                headers={headersTabelaEnderecos}
                items={itemsTable}
                options={{ print: false, search: true, pagination: true }}
                paging={paging} />
        )
    }
    return (
        <TabelaListagemFichas
            headers={headersExpandable}
            conditionButton={qrCode}
            items={itemsTable}
            paging={paging}
        />
    )
}